import type {ReactElement} from 'react';
import {Snackbar} from '@Components/snackbar';
import {SnackbarMessageGrowl} from '@Components/snackbar-message-growl';
import {useMakeTextEditableDismissWatcher} from '@Components/ai-chat-window/hooks/useMakeTextEditableDismissWatcher';

export function AiChatLoadingStates(): ReactElement {
  useMakeTextEditableDismissWatcher();

  return (
    <div className={'_position-absolute _full-width _full-height'}>
      <Snackbar zIndex={5002} />
      <SnackbarMessageGrowl zIndex={5002} />
    </div>
  );
}
